module.exports = require("vue2-filters");